/* CAVIR — panier coulissant (slide cart) façon SAVA */
(function () {
  'use strict';
  var root = document.getElementById('cv-cart');
  if (!root) return;
  var cfgEl = document.getElementById('cv-cart-cfg');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { cfg = {}; }
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var body = root.querySelector('[data-cv-body]');
  var foot = root.querySelector('[data-cv-foot]');
  var prog = root.querySelector('[data-cv-progress]');
  var compareCache = {};
  var busy = false;

  function money(c) {
    var v = (c / 100).toFixed(2).replace('.', ',');
    return (cfg.currency_symbol || '€') + v;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function open() {
    root.classList.add('is-open');
    document.documentElement.classList.add('cv-cart-lock');
    refresh();
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('cv-cart-lock');
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cv-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function getJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    });
  }
  function post(url, data) {
    return getJSON(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
  }

  function updateBubble(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (b) {
      b.classList.toggle('visually-hidden', count === 0);
    });
    document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (s) {
      s.textContent = count;
      s.classList.toggle('hidden', count === 0);
    });
  }

  function loadCompare(items) {
    var handles = [];
    items.forEach(function (i) { if (!(i.handle in compareCache) && handles.indexOf(i.handle) < 0) handles.push(i.handle); });
    return Promise.all(handles.map(function (h) {
      return getJSON(R + 'products/' + h + '.js').then(function (p) {
        var map = {};
        p.variants.forEach(function (v) { map[v.id] = v.compare_at_price || 0; });
        compareCache[h] = { variants: map, id: p.id };
      }).catch(function () { compareCache[h] = { variants: {}, id: null }; });
    }));
  }
  function compareOf(i) {
    var c = compareCache[i.handle];
    var ca = c && c.variants[i.variant_id];
    return ca && ca > i.original_price ? ca : i.original_price;
  }

  function renderProgress(cart) {
    if (!cfg.bogo_on) { prog.hidden = true; return; }
    var qty = cart.item_count;
    if (qty === 0) { prog.hidden = true; return; }
    prog.hidden = false;
    var done = qty % 2 === 0;
    prog.querySelector('[data-cv-msg]').textContent = done ? cfg.msg_done : cfg.msg_todo;
    prog.querySelector('[data-cv-bar]').style.width = done ? '100%' : '50%';
  }

  function lineHTML(i, idx, cmp) {
    var tag = '';
    if (i.discounts && i.discounts.length) {
      tag = '<div class="cv-cart__tag"><svg width="11" height="11" viewBox="0 0 16 16" fill="none"><path d="M1.5 8.6V2.2c0-.4.3-.7.7-.7h6.4l6 6-7.1 7.1-6-6Z" stroke="currentColor" stroke-width="1.3"/><circle cx="5" cy="5" r="1.2" fill="currentColor"/></svg>' + esc(i.discounts[0].title) + '</div>';
    }
    var variant = (i.variant_title && i.variant_title !== 'Default Title' && i.options_with_values && i.options_with_values.length > 1) ? '<div class="cv-cart__var">' + esc(i.variant_title) + '</div>' : '';
    var line = cmp * i.quantity;
    var oldP = line > i.final_line_price ? '<s>' + money(line) + '</s>' : '';
    return '' +
      '<div class="cv-cart__line" data-line="' + (idx + 1) + '">' +
        '<a class="cv-cart__img" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(img(i.image, 240)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="cv-cart__info">' +
          '<div class="cv-cart__top">' +
            '<div><a class="cv-cart__title" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + variant + tag + '</div>' +
            '<div class="cv-cart__prices"><span>' + money(i.final_line_price) + '</span>' + oldP + '</div>' +
          '</div>' +
          '<div class="cv-cart__bottom">' +
            '<div class="cv-cart__qty">' +
              '<button type="button" data-cv-qty="' + (i.quantity - 1) + '" aria-label="Diminuer"><svg width="10" height="10" viewBox="0 0 10 10"><path d="M0 5h10" stroke="currentColor"/></svg></button>' +
              '<span>' + i.quantity + '</span>' +
              '<button type="button" data-cv-qty="' + (i.quantity + 1) + '" aria-label="Augmenter"><svg width="10" height="10" viewBox="0 0 10 10"><path d="M0 5h10M5 0v10" stroke="currentColor"/></svg></button>' +
            '</div>' +
            '<button type="button" class="cv-cart__remove" data-cv-qty="0">' + esc(cfg.remove_label || 'Retirer') + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function render(cart) {
    updateBubble(cart.item_count);
    renderProgress(cart);
    if (!cart.items.length) {
      body.innerHTML = '<div class="cv-cart__empty"><p>' + esc(cfg.empty_text) + '</p><a class="cv-cart__btn" href="' + esc(cfg.empty_link || (R + 'collections/all')) + '">' + esc(cfg.empty_btn) + '</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    var cmpTotal = 0;
    var html = '<div class="cv-cart__lines">';
    cart.items.forEach(function (i, idx) {
      var cmp = compareOf(i);
      cmpTotal += cmp * i.quantity;
      html += lineHTML(i, idx, cmp);
    });
    html += '</div><div class="cv-cart__ups" data-cv-ups hidden><div class="cv-cart__ups-head"><h3>' + esc(cfg.ups_title) + '</h3><div><button type="button" data-cv-ups-prev aria-label="Précédent"><svg width="7" height="12" viewBox="0 0 7 12"><path d="M6 1 1 6l5 5" stroke="currentColor" fill="none" stroke-width="1.5"/></svg></button><button type="button" data-cv-ups-next aria-label="Suivant"><svg width="7" height="12" viewBox="0 0 7 12"><path d="m1 1 5 5-5 5" stroke="currentColor" fill="none" stroke-width="1.5"/></svg></button></div></div><div class="cv-cart__ups-track" data-cv-ups-track></div></div>';
    body.innerHTML = html;
    foot.querySelector('[data-cv-total]').textContent = money(cart.total_price) + ' ' + (cart.currency || '');
    var old = foot.querySelector('[data-cv-total-old]');
    old.textContent = cmpTotal > cart.total_price ? money(cmpTotal) + ' ' + (cart.currency || '') : '';
    renderUpsells(cart);
  }

  function renderUpsells(cart) {
    var box = body.querySelector('[data-cv-ups]');
    if (!box || !cfg.ups_on) return;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var first = cart.items[0];
    var src = cfg.ups_collection ? getJSON(R + 'collections/' + cfg.ups_collection + '/products.json?limit=16').then(function (d) { return d.products; })
      : getJSON(R + 'recommendations/products.json?product_id=' + first.product_id + '&limit=10&intent=related').then(function (d) { return d.products; });
    src.then(function (list) {
      var track = box.querySelector('[data-cv-ups-track]');
      var n = 0;
      var html = '';
      (list || []).forEach(function (p) {
        if (n >= 10 || inCart.indexOf(p.id) > -1) return;
        var v = p.variants && p.variants[0];
        if (!v || v.available === false) return;
        var price = typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price;
        var imgUrl = p.featured_image ? (p.featured_image.src || p.featured_image) : (p.images && p.images[0] && (p.images[0].src || p.images[0]));
        html += '<div class="cv-cart__card"><a href="' + R + 'products/' + esc(p.handle) + '" class="cv-cart__card-img">' + (imgUrl ? '<img src="' + esc(img(imgUrl, 360)) + '" alt="" loading="lazy">' : '') + '</a><button type="button" class="cv-cart__card-add" data-cv-add="' + v.id + '" aria-label="Ajouter"><svg width="16" height="16" viewBox="0 0 16 16"><path d="M0 8h16M8 0v16" stroke="currentColor"/></svg></button><a href="' + R + 'products/' + esc(p.handle) + '" class="cv-cart__card-title">' + esc(p.title) + '</a><div class="cv-cart__card-price">' + money(price) + '</div></div>';
        n++;
      });
      if (!n) return;
      track.innerHTML = html;
      box.hidden = false;
    }).catch(function () {});
  }

  function refresh() {
    return getJSON(R + 'cart.js').then(function (cart) {
      return loadCompare(cart.items).then(function () { render(cart); return cart; });
    });
  }

  function setBusy(b) { busy = b; root.classList.toggle('is-busy', b); }

  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cv-qty]');
    if (q && !busy) {
      var line = q.closest('[data-line]').getAttribute('data-line');
      setBusy(true);
      post(R + 'cart/change.js', { line: parseInt(line, 10), quantity: parseInt(q.getAttribute('data-cv-qty'), 10) })
        .then(function () { return refresh(); })
        .catch(function (err) { alertMsg(err); })
        .then(function () { setBusy(false); });
      return;
    }
    var a = e.target.closest('[data-cv-add]');
    if (a && !busy) {
      setBusy(true);
      post(R + 'cart/add.js', { items: [{ id: parseInt(a.getAttribute('data-cv-add'), 10), quantity: 1 }] })
        .then(function () { return refresh(); })
        .catch(function (err) { alertMsg(err); })
        .then(function () { setBusy(false); });
      return;
    }
    var track = body.querySelector('[data-cv-ups-track]');
    if (track && e.target.closest('[data-cv-ups-next]')) track.scrollBy({ left: track.clientWidth * 0.66, behavior: 'smooth' });
    if (track && e.target.closest('[data-cv-ups-prev]')) track.scrollBy({ left: -track.clientWidth * 0.66, behavior: 'smooth' });
  });

  function alertMsg(err) {
    var m = root.querySelector('[data-cv-error]');
    if (!m) return;
    m.textContent = (err && (err.description || err.message)) || 'Erreur, réessaie.';
    m.hidden = false;
    setTimeout(function () { m.hidden = true; }, 4000);
  }

  /* Ouvre notre panier à la place de celui du thème */
  window.addEventListener('click', function (e) {
    var t = e.target.closest('[data-testid="cart-drawer-trigger"], a[href="/cart"], a[href="' + R + 'cart"], [data-cv-open]');
    if (!t || root.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  /* Intercepte tous les ajouts au panier */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') < 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    fetch(R + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { open(); })
      .catch(function (err) { open(); setTimeout(function () { alertMsg(err); }, 400); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }, true);

  /* Ferme le panier du thème s'il s'ouvre quand même */
  function killThemeDrawer() {
    document.querySelectorAll('dialog[open]').forEach(function (d) {
      if (d.closest('cart-drawer-component') || d.querySelector('cart-drawer-component, .cart-drawer__inner, .cart-drawer__content')) { try { d.close(); } catch (e) {} }
    });
  }
  new MutationObserver(killThemeDrawer).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });

  window.CavirCart = { open: open, close: close, refresh: refresh };
  getJSON(R + 'cart.js').then(function (c) { updateBubble(c.item_count); }).catch(function () {});
})();

